/**
 * Rutas de Mantenimiento
 * Gestión de mantenimiento: planes de mantenimiento
 */
import { Route } from 'react-router-dom'
import ProtectedRoute from '../components/ProtectedRoute.jsx'
import PlanesMantenimiento from '../pages/mantenimiento/maintenancePlans.jsx'
import PlanesAsignacion from '../pages/mantenimiento/workAssignment.jsx'
import PlanesEjecucion from '../pages/mantenimiento/planExecution.jsx'
import AlmacenRepuestos from '../pages/mantenimiento/SparePartsWarehouse.jsx'
import KPI from '../pages/mantenimiento/KPI.jsx'

export const maintenanceRoutes = [
  <Route 
    key="planes-mantenimiento" 
    path="/planes-mantenimiento" 
    element={
      <ProtectedRoute>
        <PlanesMantenimiento />
      </ProtectedRoute>
    } 
  />,
  <Route
    key="planes-asignacion"
    path="/planes-asignacion"
    element={
      <ProtectedRoute>
        <PlanesAsignacion />
      </ProtectedRoute>
    }
  />,
  <Route
    key="planes-ejecucion"
    path="/planes-ejecucion"
    element={
      <ProtectedRoute>
        <PlanesEjecucion />
      </ProtectedRoute>
    }
  />,
  <Route
    key="almacen-repuestos"
    path="/almacen-repuestos"
    element={
      <ProtectedRoute>
        <AlmacenRepuestos />
      </ProtectedRoute>
    }
  />,
  <Route
    key="kpi"
    path="/kpi"
    element={
      <ProtectedRoute>
        <KPI />
      </ProtectedRoute>
    }
  />,
]

